import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Product} from '../models/product';

export const productsCompleteListActionTypes = {
  LOAD: type('[Products Complete] Load'),
  LOAD_SUCCESS: type('[Products Complete] Load Success'),
  LOAD_FAIL: type('[Products Complete] Load Error'),
  CLEAR: type('[Products Complete] CLEAR'),
};

export class LoadProductsCompleteListAction implements Action {
  readonly type = productsCompleteListActionTypes.LOAD;
  constructor() {}
}

export class LoadProductsCompleteListSuccessAction implements Action {
  readonly type = productsCompleteListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Product[]) {}
}

export class LoadProductsCompleteListFailAction implements Action {
  readonly type = productsCompleteListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class LoadProductsCompleteListClearAction implements Action {
  readonly type = productsCompleteListActionTypes.CLEAR;
  constructor(public payload?: string) {}
}
